import { useMemo } from 'react';
// Import Components
import CampaignBudgetInfo from 'components/CampaignBudgetInfo';
// Import Constants
import { l } from 'constants/common';
// Import Helpers
import { dateTimeFormat } from 'components/CampaignReport/config';

export const useDataTableColumnsConfigs = (t, partnerDateTimeFormat) => {
    return useMemo(
        () => ({
            columns: [
                {
                    text: t(l.PeriodStartDate),
                    dataKey: 'StartDate',
                    sortable: true,
                    formatter: (StartDate) => {
                        return dateTimeFormat(StartDate, partnerDateTimeFormat);
                    },
                },
                {
                    text: t(l.PeriodEndDate),
                    dataKey: 'EndDate',
                    sortable: true,
                    formatter: (EndDate) => {
                        return dateTimeFormat(EndDate, partnerDateTimeFormat);
                    },
                },
                {
                    text: t(l.BudgetSpent),
                    dataKey: 'UsedLimitValue',
                    sortable: true,
                    colRenderer: (UsedLimitValue, _index, row) => (
                        <CampaignBudgetInfo {...row.data} UsedLimit={UsedLimitValue} />
                    ),
                },
            ],
        }),
        [partnerDateTimeFormat, t],
    );
};
